import React, { forwardRef } from 'react';

/**
 * Mobile-only Success State Video Component
 * Shows the "working state" after Pluckr integration
 * Uses forwardRef to allow parent to control video playback
 */
const SuccessStateVideo = forwardRef((props, ref) => {
  return (
    <div
      id="success-video-container"
      className="success-state-video relative overflow-hidden"
      style={{
        aspectRatio: '16/9',
        maxHeight: '400px',
        background: '#000',
        borderRadius: '16px',
        margin: '16px',
        marginTop: '32px',
        width: 'calc(100% - 32px)',
        boxShadow: '0 0 20px rgba(155, 227, 143, 1)', // Pluckr green glow
      }}
      data-testid="success-state-video"
    >
      {/* Video eelement */}
      <video
        ref={ref}
        autoPlay
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/Succesx - Made with Clipchamp.mp4" type="video/mp4" />
      </video>

      {/* Placeholder content - hidden since video file is now provided */}
      <div className="video-placeholder absolute inset-0 flex flex-col items-center justify-center hidden">
        {/* Success icon */}
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mb-4"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          }}
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="rgba(255, 255, 255, 0.9)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6L9 17L4 12" />
          </svg>
        </div>

        <div className="placeholder-content text-center">
          <span
            className="placeholder-text block text-lg font-medium mb-2"
            style={{ color: 'rgba(255, 255, 255, 0.9)' }}
          >
            Success State Video
          </span>
          <span
            className="placeholder-subtext block text-sm"
            style={{ color: 'rgba(255, 255, 255, 0.7)' }}
          >
            7 sec loop
          </span>
        </div>
      </div>
    </div>
  );
});

export default SuccessStateVideo;
